import React from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';
const Rendernext = ({onNext,onPrevious}) => {
    useEffect(() => {
        AOS.init({
          duration: 1000,
          easing: "ease-in-out",
          once: true,
          delay: 12,
        });
      }, []);
    
  return (
    <div>
                    <div >
                        <div className="row">
                            <h6><b>Are there any technologies you want to specify?</b></h6>
                            <div className="d-flex flex-wrap gap-2">

                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-0">
                                    <input className="me-1 form-check-input mt-0" id="service-0" type="checkbox" value="product idea validation" />
                                    Android
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-1">
                                    <input className="me-1 form-check-input mt-0" id="service-1" type="checkbox" value="build an Mvp" />
                                    Dot NET
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-2">
                                    <input className="me-1 form-check-input mt-0" id="service-2" type="checkbox" value="Scale an existing product" />
                                    React Native
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-3">
                                    <input className="me-1 form-check-input mt-0" id="service-3" type="checkbox" value="Generate more sales" />
                                    Flutter
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-4">
                                    <input className="me-1 form-check-input mt-0" id="service-4" type="checkbox" value="Cost reduction" />
                                   IOS
                                </label>
                                {/* next line */}

                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-0">
                                    <input className="me-1 form-check-input mt-0" id="service-0" type="checkbox" value="product idea validation" />
                                    React JS
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-1">
                                    <input className="me-1 form-check-input mt-0" id="service-1" type="checkbox" value="build an Mvp" />
                                    Angular
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-2">
                                    <input className="me-1 form-check-input mt-0" id="service-2" type="checkbox" value="Scale an existing product" />
                                    Node JS
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-3">
                                    <input className="me-1 form-check-input mt-0" id="service-3" type="checkbox" value="Generate more sales" />
                                    Java
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-4">
                                    <input className="me-1 form-check-input mt-0" id="service-4" type="checkbox" value="Cost reduction" />
                                   PHP
                                </label>
                                {/* next line */}

                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-0">
                                    <input className="me-1 form-check-input mt-0" id="service-0" type="checkbox" value="product idea validation" />
                                    python
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-1">
                                    <input className="me-1 form-check-input mt-0" id="service-1" type="checkbox" value="build an Mvp" />
                                    DevOps
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-2">
                                    <input className="me-1 form-check-input mt-0" id="service-2" type="checkbox" value="Scale an existing product" />
                                    Javascript
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-3">
                                    <input className="me-1 form-check-input mt-0" id="service-3" type="checkbox" value="Generate more sales" />
                                    Laravel
                                </label>
                                {/* Next line */}
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-0">
                                    <input className="me-1 form-check-input mt-0" id="service-0" type="checkbox" value="product idea validation" />
                                    Wordpress
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-1">
                                    <input className="me-1 form-check-input mt-0" id="service-1" type="checkbox" value="build an Mvp" />
                                    Square space
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-2">
                                    <input className="me-1 form-check-input mt-0" id="service-2" type="checkbox" value="Scale an existing product" />
                                    Go high level
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-3">
                                    <input className="me-1 form-check-input mt-0" id="service-3" type="checkbox" value="Generate more sales" />
                                    Calendly
                                </label>
                                {/* Next line */}
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-0">
                                    <input className="me-1 form-check-input mt-0" id="service-0" type="checkbox" value="product idea validation" />
                                    PostgreSQL
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-1">
                                    <input className="me-1 form-check-input mt-0" id="service-1" type="checkbox" value="build an Mvp" />
                                    Wix
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-2">
                                    <input className="me-1 form-check-input mt-0" id="service-2" type="checkbox" value="Scale an existing product" />
                                    Bubble.IO
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-3">
                                    <input className="me-1 form-check-input mt-0" id="service-3" type="checkbox" value="Generate more sales" />
                                    Dante AI
                                </label>
                                {/* Next Line */}
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-0">
                                    <input className="me-1 form-check-input mt-0" id="service-0" type="checkbox" value="product idea validation" />
                                    Zapier
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-1">
                                    <input className="me-1 form-check-input mt-0" id="service-1" type="checkbox" value="build an Mvp" />
                                    Tailwind CSS
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-2">
                                    <input className="me-1 form-check-input mt-0" id="service-2" type="checkbox" value="Scale an existing product" />
                                    Bootstrap
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-3">
                                    <input className="me-1 form-check-input mt-0" id="service-3" type="checkbox" value="Generate more sales" />
                                    AWS Cloud
                                </label>
                                {/* Next line */}
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-0">
                                    <input className="me-1 form-check-input mt-0" id="service-0" type="checkbox" value="product idea validation" />
                                    One Signal
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-1">
                                    <input className="me-1 form-check-input mt-0" id="service-1" type="checkbox" value="build an Mvp" />
                                    SignalR
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-2">
                                    <input className="me-1 form-check-input mt-0" id="service-2" type="checkbox" value="Scale an existing product" />
                                    Pusher
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-3">
                                    <input className="me-1 form-check-input mt-0" id="service-3" type="checkbox" value="Generate more sales" />
                                    MySQL
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-2">
                                    <input className="me-1 form-check-input mt-0" id="service-2" type="checkbox" value="Scale an existing product" />
                                    Material UI
                                </label>
                                <label className="p-2 px-3 rounded-3 d-flex align-items-center shadow-sm" for="service-3">
                                    <input className="me-1 form-check-input mt-0" id="service-3" type="checkbox" value="Generate more sales" />
                                    MS SQL Server
                                </label>
                            </div>

                        </div>

                        
                        <div className="d-flex justify-content-between py-3 gap-4">
                        <button
                                className="btn-fill text-white p-2 rounded-3"
                                type="button"
                                onClick={() => onPrevious()}
                            >
                                Previous<i className="fa-solid fa-arrow-left text-white ms-2"></i>
                            </button>
                            <button  onClick={() => { onNext() }} className="btn-fill text-white rounded-3" type="submit">
                                Next<i className="fa-solid fa-arrow-right text-white ms-2"></i>
                            </button>
                        </div>
                    </div>
    </div>
  )
}

export default Rendernext